var _path, _path2, _path3, _path4, _path5;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPrice(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1732695710729,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 9249,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    height: 500,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512.3 959.4c-2.4 0-4.9-0.4-7.2-1.3-2.2-0.9-55.4-21.6-122.3-62.3-39.3-24-75.3-49.9-106.8-77.1-39.7-34.3-72.6-70.8-97.7-108.4-40.2-60.3-41-138.5-41-141.8V157.2c0-9.5 6.6-17.6 15.9-19.6 1-0.2 104-22 187.7-41.1 109.9-25 166.5-31.5 168.9-31.8 1.7-0.2 3.4-0.2 5 0.1 0.7 0.1 74.8 10.6 159.9 28.2 97 20.1 195.8 44.6 196.8 44.8 8.9 2.2 15.2 10.2 15.2 19.4V568c0.2 7.3 1.8 88.1-35.9 155.9-26.9 48.4-91 102.6-190.6 161.1-72.8 42.8-137 71.5-139.7 72.7-2.7 1.1-5.4 1.7-8.2 1.7z m-335-391.2c0 1.8 1.2 70 34.3 119.8 89.7 134.7 262 213.4 300.2 229.6 43-20 252.8-121.3 303.9-213.2 33.3-59.9 30.9-134.6 30.9-135.3V172.9c-31.3-7.6-106.3-25.5-180.1-40.8-74.9-15.5-141-25.4-154.7-27.4-11.9 1.5-67.1 9.2-162 30.8-64.4 14.7-140.2 30.9-172.5 37.8v394.9z",
    "p-id": 9250,
    fill: "#1296db"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M369.2 439h285.6v40H369.2z",
    "p-id": 9251,
    fill: "#1296db"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M492 457h40v253.7h-40z",
    "p-id": 9252,
    fill: "#1296db"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M369.2 552.7h285.6v40H369.2zM373.36 305.892l31.02-25.256L546.255 454.89l-31.02 25.256z",
    "p-id": 9253,
    fill: "#1296db"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M492.85 427.264l119.397-146.647 31.02 25.256L523.87 452.52z",
    "p-id": 9254,
    fill: "#1296db"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPrice);
export default __webpack_public_path__ + "static/media/price.07a9394e56b1a2501c53608eb97f7b39.svg";
export { ForwardRef as ReactComponent };